import React from 'react';

interface ButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  variant?: 'primary' | 'secondary' | 'outline' | 'ghost';
  size?: 'sm' | 'md' | 'lg';
  children: React.ReactNode;
}

export const Button: React.FC<ButtonProps> = ({ 
  variant = 'primary', 
  size = 'md', 
  className = '', 
  children, 
  ...props 
}) => {
  const baseStyles = "inline-flex items-center justify-center transition-all duration-300 font-bold tracking-widest uppercase focus:outline-none disabled:opacity-50 disabled:cursor-not-allowed rounded-2xl whitespace-nowrap";
  
  const variants = {
    primary: "bg-orange-600 text-white hover:bg-orange-500 shadow-lg shadow-orange-500/20",
    secondary: "bg-stone-100 text-stone-900 hover:bg-stone-200 border border-stone-200",
    outline: "border-2 border-orange-200 text-orange-700 hover:border-orange-500 hover:bg-orange-50 bg-transparent",
    ghost: "text-stone-900 hover:bg-orange-50 bg-transparent",
  };

  const sizes = {
    sm: "text-[8px] px-3 py-1.5",
    md: "text-[9px] px-5 py-2.5",
    lg: "text-[10px] px-6 py-3",
  };

  return (
    <button 
      className={`${baseStyles} ${variants[variant]} ${sizes[size]} ${className}`} 
      {...props}
    >
      {children}
    </button>
  );
};